import { useCallback, useEffect, useState } from "react";
import { Layout } from "../../components/layout/Layout";
import { api } from "../../lib/api";
import { FeuilleTemps, currentMois } from "../../components/FeuilleTemps";

export default function MonPointagePage() {
  const [mois, setMois] = useState(currentMois());
  const [feuille, setFeuille] = useState(null);
  const load = useCallback(() => {
    api.get("/pointage/mes-pointages", { params: { mois } }).then((r) => setFeuille(r.data)).catch(() => setFeuille(null));
  }, [mois]);
  useEffect(() => { setFeuille(null); load(); }, [load]);
  return (
    <Layout title="Mon pointage">
      <p className="text-sm text-muted-foreground mb-3">
        Vos heures détaillées. Les horaires en rouge sont hors de l'horaire prévu (±5 min) et doivent être approuvés par votre gestionnaire ; ils passent au vert une fois acceptés.
      </p>
      <FeuilleTemps feuille={feuille} mois={mois} onMois={setMois} onChanged={load} />
    </Layout>
  );
}
